module.exports = {
      id: "b19632713e996f624d4c5f968697486fconstruction-mix.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#b19632713e996f624d4c5f968697486fconstruction-mix.svg",
      toString: function () {
        return this.url;
      }
    }